import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, filter, map, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';

import * as OrgActions from './org.actions';
import * as OrgSelectors from './org.selectors';
import { AccountClientService } from '@mode/shared/data-access-webapp';
import { Store } from '@ngrx/store';

@Injectable()
export class OrgEffects {
  loadCurrentOrg$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(OrgActions.loadCurrentOrg),
      withLatestFrom(this.store.select(OrgSelectors.selectCurrent)),
      filter(([action, current]) => action.username !== current?.username), // don't attempt to reload the same org
      switchMap(([action]) => {
        return this.client.getOrganization(action.username);
      }),
      map((org) =>
        OrgActions.loadCurrentOrgSuccess({
          org,
        })
      ),
      catchError((error) => of(OrgActions.loadCurrentOrgFailure({ error })))
    );
  });

  loadReportOwner$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(OrgActions.loadReportOwner),
      withLatestFrom(this.store.select(OrgSelectors.selectReport)),
      filter(([action, current]) => action.username !== current?.username), // don't attempt to reload the same org
      switchMap(([action]) => {
        return this.client.getOrganization(action.username);
      }),
      map((org) =>
        OrgActions.loadReportOwnerSuccess({
          org,
        })
      ),
      catchError((error) => of(OrgActions.loadReportOwnerFailure({ error })))
    );
  });

  constructor(private actions$: Actions, private store: Store, private client: AccountClientService) {}
}
